import ReducerBuilder from "../../classes/ReducerBuilder";
import * as ResourceApi from "api/resources";
import {Observable} from 'rxjs/Observable';
import {filterOptionsFactory, sortOptionsFactory} from "../../viewOptions/factories";
import {toggleSort} from "../../utils/DBUtils";
import {createdResourceAction} from "../../resources/actions";

const initialState = {
    searchText: "",
};

const ActionTypes = {
    UPDATE_RELATED_BREAK_SEARCH_TEXT: "UPDATE_RELATED_BREAK_SEARCH_TEXT",
    SEND_RELATED_BREAK_SEARCH: "SEND_RELATED_BREAK_SEARCH",
    RECEIVED_RELATED_BREAK_SEARCH_RESULTS: "RECEIVED_RELATED_BREAK_SEARCH_RESULTS",
    CREATE_RELATED_BREAK_FROM_SELECTION: "CREATE_RELATED_BREAK_FROM_SELECTION",
    CREATED_RELATED_BREAK: "CREATED_RELATED_BREAK"
};

export const updateRelatedBreakSearchTextAction = ({text}) => ({
    type: ActionTypes.UPDATE_RELATED_BREAK_SEARCH_TEXT,
    text
});

export const createRelatedBreakFromSelection = (data) => ({
    type: ActionTypes.CREATE_RELATED_BREAK_FROM_SELECTION,
    ...data
});

const receivedRelatedBreakSearchResults = (results) => ({
    type: ActionTypes.RECEIVED_RELATED_BREAK_SEARCH_RESULTS,
    results
});

export const reducer = new ReducerBuilder(initialState)
    .forType(ActionTypes.UPDATE_RELATED_BREAK_SEARCH_TEXT)
    .reduce((state, {text}) => {
        state.searchText = text;
    })
    .forType(ActionTypes.SEND_RELATED_BREAK_SEARCH)
    .reduce((state) => {
        state.loading = true;
    })
    .forType(ActionTypes.RECEIVED_RELATED_BREAK_SEARCH_RESULTS)
    .reduce((state, {results}) => {
        state.loading = false;
        state.searchResults = results;
    })
    .forType(ActionTypes.CREATE_RELATED_BREAK_FROM_SELECTION)
    .reduce((state) => {
        state.searchText = "";
    })
.build();

const searchBreaksEpic = (action$) => action$.ofType(ActionTypes.UPDATE_RELATED_BREAK_SEARCH_TEXT)
    .throttleTime(500)
    .map(() => ({type: ActionTypes.SEND_RELATED_BREAK_SEARCH}));

const sendRelatedBreakSearch = (action$, store) => action$.ofType(ActionTypes.SEND_RELATED_BREAK_SEARCH)
    .mergeMap(() => {
        const {relatedBreaks} = store.getState();
        const {searchText} = relatedBreaks;

        const sortOptions = sortOptionsFactory('_created');
        sortOptions.sorts = toggleSort(sortOptions.sorts, '_created');

        const filterOptions = filterOptionsFactory({
            filters: [
                {field: 'platform', value: "MASTER"},
            ]
        });

        return ResourceApi.searchResources(ResourceApi.Types.Break, searchText, sortOptions, filterOptions, 10)
            .map(({response: {object}}) => {
                return receivedRelatedBreakSearchResults(object);
            }).catch((error) => {
                console.error(error);
                // in case a search fails this epic won't break
                return receivedRelatedBreakSearchResults([]);
            });
    });

const createRelatedBreakEpic = (action$) => action$.ofType(ActionTypes.CREATE_RELATED_BREAK_FROM_SELECTION)
    .mergeMap(({selection, rootResource, resourceIds, resourcePath, fieldPath}) => {
        return ResourceApi.create(
            ResourceApi.Types.RelatedBreak,
            {
                text: selection.title,
                link: selection.permalink
            },
            resourceIds
        ).mergeMap(({response: {object, modifiedBreak}}) => {
            const relatedBreakFieldPath = fieldPath.concat("relatedBreaks");
            return Observable.of(
                {type: ActionTypes.CREATED_RELATED_BREAK, relatedBreak: object},
                createdResourceAction(object, rootResource, resourceIds, resourcePath, relatedBreakFieldPath, modifiedBreak)
            )
        });
    });

export const epics = [
    searchBreaksEpic,
    sendRelatedBreakSearch,
    createRelatedBreakEpic
];


// WEBPACK FOOTER //
// ./public/pages/RelatedBreakEditor/reducer.js